import { render, staticRenderFns } from "./CommunityOverview.vue?vue&type=template&id=3ef2793c"
import script from "./CommunityOverview.vue?vue&type=script&lang=js"
export * from "./CommunityOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports